import { newNotification, notificationExists } from '../utils/notifications';

import actions from '../actions';

function* add(reduction, notification) {
  function updateNotifications(notifications) {
    return notifications.push(newNotification(notification));
  }

  return notificationExists({ notification, notifications: reduction.get('notifications') })
    ? reduction
    : reduction.update('notifications', updateNotifications);
}

function* remove(reduction, id) {
  function updateNotifications(items) {
    function filterNotifications(notification) {
      return notification.get('id') !== id;
    }

    return items.filter(filterNotifications);
  }

  return reduction.update('notifications', updateNotifications);
}

const notifications = {
  [actions.notifications.add]: add,
  [actions.notifications.remove]: remove,
};

export default notifications;
